import { IonButton } from '@ionic/react';
import classNames from 'classnames';
import React from 'react';
import styles from './IconButton.module.css';
interface ButtonProps {
	icon: JSX.Element;
	label?: string | number | JSX.Element;
	onClick?: (e: any) => void;
	className?: string;
	href?: string;
	fill?: 'clear' | 'outline' | 'solid' | 'default';
	iconRight?: boolean;
	iconColor?: string;
	color?: 'primary' | 'secondary' | 'tertiary';
	disabled?: boolean;
	outline?: boolean;
	testId?: string;
}

export const IconButton: React.FC<ButtonProps> = ({
	icon,
	label,
	onClick,
	iconRight,
	className,
	href,
	fill,
	disabled,
	color,
	iconColor,
	outline,
	testId
}) => (
	<IonButton
		className={classNames(['icon-button', styles.textSmall, outline ? styles.outline : '', className && className])}
		fill={fill || 'clear'}
		color={color}
		target="_self"
		disabled={disabled}
		href={href && href}
		onClick={onClick && onClick}
		style={{
			'--color': fill && fill === 'solid' && !color ? 'var(--neutral10)' : 'var(--neutral700)'
		}}
		data-testid={testId}
	>
		{!iconRight && (
			<div className={classNames([styles.icon])} style={{ color: iconColor && iconColor }}>
				{icon}
			</div>
		)}
		{label && (
			<div className={styles.label} style={{ paddingRight: fill && fill === 'solid' ? 10 : 0 }}>
				{label}
			</div>
		)}
		{iconRight && (
			<div className={styles.icon} style={{ color: iconColor }}>
				{icon}
			</div>
		)}
	</IonButton>
);
